import { useState } from "react";

export function useAuthViewStore() {
  const [openCloseAuthModal, setOpenCloseAuthModal] = useState(false);
  return {
    openCloseAuthModal,
    setOpenCloseAuthModal,
  };
}
